<template>
    <div class="h-custom container">
      <div v-if="!shallShowConfirmationStep" class="row mt-4 h-100" style="border-radius: 1rem;">
        <div v-if="!forgotPs" class="col-12 col-xl-7 col-lg-7 col-md-7  order-1 order-xl-0 order-lg-0 order-md-0">
          <div v-if="errorMessageLog" class="alert alert-danger d-flex align-items-center" role="alert">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2" viewBox="0 0 16 16" role="img" aria-label="Warning:">
              <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
            </svg>
            <div>
              {{ errorMessageLog }}
            </div>
          </div>
          <div class="card shadow-sm mb-1">
            <div class="card-body">
              <div v-if="!alreadyRegistered && errorMessageReg.message" class="alert alert-danger d-flex align-items-center" role="alert">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2" viewBox="0 0 16 16" role="img" aria-label="Warning:">
                    <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                  </svg>
                  <div>
                    {{ errorMessageReg.message }}
                  </div>
                </div>
              <div class="form-outline mb-3">
                <h5 :class="((alreadyRegistered || isFirstStep || isLoadingCheck) ? 'log-in' : 'register') + '-header text-secondary text-start mb-3 big-title'" >{{ (alreadyRegistered || isFirstStep || isLoadingCheck) ? 'Log in' : 'Register' }}</h5>
                <!-- <h5 v-if="!isFirstStep && !loginRegister" class="text-secondary text-start mb-3">{{ alreadyRegistered ? translate('Login') : translate('Create account') }}</h5> -->
                <!-- Login form -->
                <label v-if="isFirstStep || isLoadingCheck" for="email-address" class="mb-2 text-start me-1 for-login-label">
                  {{ 'Email' }}
                </label>
                  <form
                    v-if="isFirstStep || isLoadingCheck"
                    @submit.prevent="checkEmail"
                    class="row px-3 pb-1"
                  >
                    <input
                      required
                      type="email"
                      placeholder="Email"
                      v-model="initEmail"
                      class="form-control col-12"
                      @keyup="$emit('reset-errorMessage')"
                    >
                    <button v-if="isFirstStep || isLoadingCheck" type="submit" class="btn btn-primary text-nowrap mt-3" @click="$emit('reset-errorMessage')">{{ translate('Log in') }}</button>
                    <!-- <button v-if="!isFirstStep" @click="isFirstStep = true; $emit('reset-errorMessage')" class="btn ms-1 btn-primary">{{ translate('Edit') }}</button> -->
                  </form>
                  <!-- <button v-if="isFirstStep" @click="listenBack()" class="btn ms-1 btn-secondary">{{ translate('Back') }}</button> -->
              </div>
              <!-- Registration form -->
              <form v-if="!isFirstStep && !isLoadingCheck" @submit.prevent="checkout(alreadyRegistered ? 'login' : 'register')">
                <div class="row">
                  <div v-if="!alreadyRegistered || (loginRegister && !register.email)" class="form-outline mb-3 col-12">
                    <label for="first-name" class="text-nowrap mb-2">Email <small style="color: #ea5455">*</small></label>
                    <input @blur="checkRegistrationEmail" required type="text" placeholder="Email" :disabled="loginRegister" v-model="register.email" class="form-control" :class="errorMessageReg.email[0] ? 'is-invalid' : ''" @keyup="$emit('reset-errorMessage')">
                    <small v-if="errorMessageReg.email.length > 0" style="color: #ea5455">{{ errorMessageReg.email[0] }}</small>
                    <div v-if="!alreadyRegistered || (loginRegister && !register.email)" class="alert mt-3 d-flex align-items-center" style="background: #f1f4ff" role="alert">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#0a54fd" class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16">
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
                      </svg>
                      <span class="ms-1">Your email address serves you as username.</span>
                    </div>
                  </div>
                  <div v-if="!alreadyRegistered || (loginRegister && !register.firstname)" class="form-outline mb-3 col-12 col-xl-6">
                    <label for="first-name" class="text-nowrap mb-2">First name <small style="color: #ea5455">*</small></label>
                    <input required type="text" placeholder="First name" :disabled="loginRegister" v-model="register.firstname" class="form-control" :class="errorMessageReg.firstname[0] ? 'is-invalid' : ''" @keyup="$emit('reset-errorMessage')">
                    <small v-if="errorMessageReg.firstname.length > 0" style="color: #ea5455">{{ errorMessageReg.firstname[0] }}</small>
                  </div>
                  <div
                    v-if="!alreadyRegistered || (loginRegister && !register.lastname)"
                    class="form-outline mb-3 col-12 col-xl-6"
                  >
                    <label for="last-name" class="text-nowrap mb-2">Last name <small style="color: #ea5455">*</small></label>
                    <input required type="text" placeholder="Last name" :disabled="loginRegister" v-model="register.lastname" class="form-control" :class="errorMessageReg.lastname[0] ? 'is-invalid' : ''" @keyup="$emit('reset-errorMessage')">
                    <small v-if="errorMessageReg.lastname.length > 0" style="color: #ea5455">{{ errorMessageReg.lastname[0] }}</small>
                  </div>
                  <div v-show="(!alreadyRegistered && !loginRegister) ||  (loginRegister && !registerReplacer.dob)" class="mb-3 col-12 col-xl-6">
                    <table id="tblForm" border="0" cellpadding="5" cellspacing="0" style="width: 100%">
                        <tr class="text-nowrap d-block">
                            <td class="p-0 pb-2">Birth date <small class="d-inline" style="color: #ea5455">*</small></td>
                        </tr>
                        <tr>
                            <input id="dobInput" placeholder="DD/MM/YYYY" v-model="initDob" type="text" class="date-format form-control" :class="errorMessageReg.dob[0] ? 'is-invalid' : ''" />
                        </tr>
                        <tr>
                            <td><small class="error text-danger ms-0 text-start" style="display: none; color: #ea5455 !important">Invalid Date. Only dd/MM/yyyy format allowed.</small></td>
                        </tr>
                    </table>
                  </div>
                  <div v-if="(!alreadyRegistered && !loginRegister) ||  (loginRegister && !registerReplacer.gender)" class="col-12 form-outline col-xl-6 mb-3">
                    <label for="gener" class="mb-2">Gender <small style="color: #ea5455">*</small></label>
                    <div class="gender d-flex justify-content-start">
                        <div class="form-check d-flex align-items-end me-2">
                          <input @change="register.gender = 'male'" class="form-check-input me-1" type="radio" name="flexRadioDefault" id="flexRadioDefault1" checked>
                          <label class="form-check-label" for="flexRadioDefault1">
                            Male
                          </label>
                        </div>
                        <div class="form-check d-flex align-items-end me-2">
                          <input @change="register.gender = 'female'" class="form-check-input me-1" type="radio" name="flexRadioDefault" id="flexRadioDefault2" >
                          <label class="form-check-label" for="flexRadioDefault2">
                            Female
                          </label>
                        </div>
                        <div class="form-check d-flex align-items-end">
                          <input @change="register.gender = 'other'" class="form-check-input me-1" type="radio" name="flexRadioDefault" id="flexRadioDefault3" >
                          <label class="form-check-label" for="flexRadioDefault3">
                            Other
                          </label>
                        </div>
                      </div>
                  </div>
                </div>
                <div class="row">
                <div v-if="(!alreadyRegistered && !loginRegister) ||  (loginRegister && !registerReplacer.address)" class="form-outline mb-3">
                  <label for="address" class="text-nowrap mb-2">Address <small style="color: #ea5455">*</small></label>
                  <input required type="text" placeholder="Address" v-model="register.address" class="form-control col">
                </div>
                <div v-if="(!alreadyRegistered && !loginRegister) ||  (loginRegister && (!registerReplacer.postcode || !registerReplacer.city))" class="form-outline mb-3">
                  <label for="postal-city" class="text-nowrap mb-2">Postal code - City <small style="color: #ea5455">*</small></label>
                  <div class="d-flex" style="padding: 0 !important">
                    <input required  placeholder="Postal code" v-model="register.postcode" class="form-control me-1" style="width: 20%">
                    <input required type="text" placeholder="City" v-model="register.city" class="form-control" style="width: 80%">
                  </div>
                </div>
                <div class="row listsrow">
                  <div v-if="(!alreadyRegistered && !loginRegister) ||  (loginRegister && !registerReplacer.country)" class="form-outline mb-3 col-6">
                    <label for="country" class="text-nowrap mb-2">Country <small style="color: #ea5455">*</small></label>
                    <v-select :clearable="false" class="me-1" v-model="register.country" :options="countries" label="name">
                      <template #selected-option="{ name }">
                        <span :class="name ? 'p-1' : 'pb-4 mb-1'">{{ name }}</span>
                      </template>
                    </v-select>
                  </div>
                  <div v-if="(!alreadyRegistered && !loginRegister) ||  (loginRegister && !registerReplacer.country)" class="form-outline mb-3 col-6">
                  <label for="nationality" class="text-nowrap mb-2">Nationality <small style="color: #ea5455">*</small></label>
                  <v-select :clearable="false" class="me-1" v-model="register.nationality" :options="countries" label="nationality">
                    <template #selected-option="{ nationality }">
                      <span :class="nationality ? 'p-1' : 'pb-4 mb-1'">{{ nationality }}</span>
                    </template>
                  </v-select>
                </div>
                </div>
                <div v-if="(!alreadyRegistered && !loginRegister) ||  (loginRegister && !registerReplacer.phone)" class="row listsrow mb-3">
                  <label for="phone" required class="text-nowrap mb-2" style="padding-left: 0">Telephone mobile <small style="color: #ea5455">*</small></label>
                  <div class="d-flex align-items-stretch">
                    <v-select :clearable="false" class="countryPhone" v-model="Pcountry" style="width: 30%" :options="countries" label="name">
                      <template #selected-option="{ dial_code }">
                        <span :class="dial_code ? 'p-1' : 'pb-4 mb-1'">{{ dial_code }}</span>
                      </template>
                    </v-select>
                    <input required type="number" placeholder="Phone" v-model="register.phone" class="form-control ms-1" style="width: 70%">
                  </div>
                </div>
                <div v-if="!alreadyRegistered && !loginRegister" class="mb-0 mt-3">
                  <div class="alert" style="background: #f1f4ff" role="alert">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#0a54fd" class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16">
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
                    </svg>
                    <small class="ms-1">
                      Enter the mobile phone number and email address for this student. 
                      These details will be used in the event of a disturbance, 
                      so that we can send a message to all students in this course. 
                      We can also call you or send you a text message with your course details at this number if we cannot reach you by email.
                    </small>
                </div>
                </div>
                  <!-- Payer -->
                  <div v-if="!alreadyRegistered" class="row listsrow mb-3">
                    <h5 v-if="loginRegister" class="mb-3">Payer informations </h5>
                    <hr v-if="!loginRegister">
                    <label for="who-pays" class="text-nowrap mb-2 me" style="padding-left: 0">Who will be paying? <small style="color: #ea5455">*</small></label>
                    <v-select :clearable="false"
                              label="name"
                              class="mb-3 col px-0"
                              v-model="register.who_pays"
                              :options="isAdmission"
                    />
                    <div v-if="register.who_pays && register.who_pays.code === 'duo'" class="alert alert-danger d-flex align-items-center" style="padding: 15px" role="alert">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#dc3545" class="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                        <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>
                        <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>
                      </svg>
                      <small class="ms-1">Please <a :href="schoolContact" target="_blank">contact the school</a> to pay with DUO, or choose a different payer</small>
                    </div>
                  </div>
                  <div v-if="!alreadyRegistered && register.who_pays && (register.who_pays.code === 'company' || register.who_pays.code === 'payer')" class="form-outline mb-3">
                    <label for="payer-name" class="text-nowrap mb-2">Payer name <small style="color: #ea5455">*</small></label>
                    <input required type="text" :placeholder="register.who_pays.code === 'company' ? 'Company name' : 'Name of Payer'" v-model="register.payer_name" class="form-control">
                  </div>
                  <div v-if="!alreadyRegistered && register.who_pays && register.who_pays.code === 'company'" class="form-outline mb-3">
                    <label for="company-number" class="text-nowrap mb-2">Company org.number <small style="color: #ea5455">*</small></label>
                    <input required type="text" placeholder="Company org.number" v-model="register.company_number" class="form-control">
                  </div>
                  <div v-if="!alreadyRegistered && register.who_pays && (register.who_pays.code === 'company' || register.who_pays.code === 'payer')" class="form-outline mb-3">
                    <label for="invoicing-address" class="text-nowrap mb-2">Invoicing address <small style="color: #ea5455">*</small></label>
                    <input required type="text" placeholder="Invoicing address" v-model="register.payer_address" class="form-control">
                  </div>
                  <div v-if="!alreadyRegistered && register.who_pays && register.who_pays.code === 'company'" class="form-outline mb-3">
                    <label for="responsible" class="text-nowrap mb-2">Responsible / contact person <small style="color: #ea5455">*</small></label>
                    <input required type="text" placeholder="Responsible / contact payer" v-model="register.responsible" class="form-control">
                  </div>
                  <div v-if="!alreadyRegistered && register.who_pays && (register.who_pays.code === 'company' || register.who_pays.code === 'payer')" class="form-outline mb-3">
                    <label for="phone" class="text-nowrap mb-2">Phone number <small style="color: #ea5455">*</small></label>
                    <input required type="text" placeholder="Phone number" v-model="register.payer_phone" class="form-control">
                  </div>
                  <div v-if="!alreadyRegistered && register.who_pays && (register.who_pays.code === 'company' || register.who_pays.code === 'payer')" class="form-outline mb-3">
                    <label for="email" class="text-nowrap mb-2">Email address <small style="color: #ea5455">*</small></label>
                    <input required type="email" placeholder="Email address" v-model="register.payer_email" class="form-control">
                  </div>
                  <div v-if="!alreadyRegistered && register.who_pays && register.who_pays.code === 'company'">
                    <label for="email" class="text-nowrap mb-2">Payment preference <small style="color: #ea5455">*</small></label>
                    <div class="d-flex py-3">
                      <div v-if="!alreadyRegistered" class="form-check me-5">
                        <input @change="register.companyPaymentMethod = 'Card'" class="form-check-input" type="radio" name="flexRadioDefault1" id="flexRadioDefault4" checked>
                        <label class="form-check-label" for="flexRadioDefault4">
                          By card
                        </label>
                      </div>
                      <div v-if="!alreadyRegistered" class="form-check me-2">
                        <input @change="register.companyPaymentMethod = 'Invoice'" class="form-check-input" type="radio" name="flexRadioDefault1" id="flexRadioDefault5" >
                        <label class="form-check-label" for="flexRadioDefault5">
                          By invoice
                        </label>
                      </div>
                  </div>
                  </div>
                </div>

                <div v-if="alreadyRegistered" class="form-outline mb-3">
                  <div class="d-flex justify-content-between">
                    <label for="password" class="text-nowrap mb-2">Password</label>
                    <small class="mb-0">
                      <a type="button" data-bs-toggle="modal" data-bs-target="#forgotPwModal" style="color: var(--primary);" class="text-primary-50 fw-bold">
                        {{translate('Forgot password?')}}
                      </a>
                    </small>
                    <div class="modal fade" id="forgotPwModal" data-bs-backdrop="static" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                      <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Forgot password?</h5>
                            <button type="button" @click="isValidinitEmail = false" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                          </div>
                          <div class="modal-body">
                            <forgot-password
                              :email="initEmail"
                              :is-valid="isValidinitEmail"
                              @valdate-email="isValidinitEmail = true"
                              @back-to-login="forgotPs = false"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <input required type="password" placeholder="Password" @keyup="$emit('reset-errorMessage')" v-model="login.password" class="form-control form-control">
                </div>

                <!-- <hr> -->
                <div v-if="!alreadyRegistered && !loginRegister" class="form-outline mb-3 row">
                  <label for="heard-from" class="text-nowrap mb-2">How did you hear about us?</label>
                  <v-select :disabled="register.who_pays.code && register.who_pays.code === 'duo'" :clearable="false" class="mb-2 col px-0 hear_about" v-model="register.howHeared" :options="howHeareds" />
                </div>
                <div v-if="!alreadyRegistered && !loginRegister" class="mb-3 row listsrow" style="padding: 12px !important;">
                  <label for="exampleFormControlTextarea1" class="form-label">Comments</label>
                  <textarea :disabled="register.who_pays.code && register.who_pays.code === 'duo'" v-model="register.comments" class="form-control" placeholder="Comments" id="exampleFormControlTextarea1" rows="2"></textarea>
                </div>
                <div v-if="!alreadyRegistered && !loginRegister" class="form-check">
                  <input :disabled="register.who_pays.code && register.who_pays.code === 'duo'" @change="isActive = !isActive" class="form-check-input" :class="isActive ? 'checked' : ''" type="checkbox" id="flexCheckDefault">
                  <label class="text-start form-check-label" for="flexCheckDefault">
                    I have read and accepted the {{ schoolName }}'s school regulations, registration <a target="_blank" :href="`${termsLink}`"> conditions (contract terms) and payment terms. </a>
                  </label>
                </div>
                <div class="d-grid gap-2 mt-2">
                  <button v-if="!alreadyRegistered" :disabled="!isActive && !loginRegister || errorMessageReg.email[0] || (initDob && initDob.length < 10) || register.who_pays.code && register.who_pays.code === 'duo'" value="Register" class="btn btn-primary">{{ 'Next' }}</button>
                  <button v-if="alreadyRegistered" value="Register" class="btn btn-primary">{{ translate('Login') }}</button>
                  <button type="submit" value="Back" @click="initEmail = null; isFirstStep = true; $emit('hide-login-register')" class="m-1 btn btn-outline-secondary">{{translate('Back')}}</button>
                </div>
              </form>
            </div>
          </div>
          <div class="create-account" v-if="alreadyRegistered || isFirstStep || isLoadingCheck">
            <div class="line-with-text p-3">
              <span>New to {{ schoolName }}?</span>
            </div>
            <button
              @click="$emit('toggle-register', false, false); ShowConfirmationStep = false; isFirstStep = false; initEmail = null; bDateListener()"
              class="btn btn-block ms-1 btn-secondary"
              style="width: 100%"
            >
              {{ translate('Create account') }}
            </button>
          </div>
        </div>
        <div class="col-12 col-xl-5 col-lg-5 col-md-5 order-0 order-xl-1 order-lg-1 order-md-1">
          <div class="card shadow-sm mb-3">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <h5 class="text-secondary" style="display: none">{{translate('Summary')}}</h5>
                <h6 class="text-secondary">{{ courses.length }} {{ courses.length === 1  ? `course` : `courses`}}</h6>
                <h6>
                  <span :style="isDiscounted || isCoupon ? 'text-decoration: line-through' : ''">{{ courses.map(course => parseFloat(course.price)).reduce((a, b) => a + b, 0) }} {{ currency }} </span>
                  <br>
                  <span style="color: var(--primary); font-size: larger" v-if='isDiscounted && ! isCoupon' >{{ courses.map(course => parseFloat(course.Discounted.price ?? course.price)).reduce((a, b) => a + b, 0) }} {{ currency }}</span>
                  <span style="color: var(--primary); font-size: larger" v-if='isCoupon' >{{ theTotal }} {{ currency }}</span>
                </h6>
              </div>
              <!-- <hr class="text-seconday m-0"> -->
              <div v-for="course in courses" :key="course.id" class="p-2">
                <div class="d-flex align-items-center justify-content-between mb-1">
                  <strong class="text-truncate mt-1 mb-1 course-title" data-bs-toggle="tooltip" data-bs-placement="top" :title="course.Name" style="color: var(--primary); max-width: 300px; margin: -8px;">{{ course.Name }}</strong>
                  <small v-if="course.master_course && course.id !== 13532" class="badge" :class="course.master_course.classroom_type === 'classroom' ? 'bg-danger' : 'bg-success'" :style="{ 'background-color': course.master_course.classroom_type === 'classroom' ? 'var(--primary) !important' : '#00628f !important' }">
                    {{ course.master_course.classroom_type }}
                  </small>
                </div>
                <div class="mb-1">
                  <small
                    v-if="(course.date_start || course.date_end) && course.id !== 13532"
                    class="text-secondary me-1 course-dates">
                    {{ formatDate((type !== 'individual' ? course : individual).date_start) }} to {{ formatDate((type !== 'individual' ? course : individual).date_end) }}
                  </small>
                  <small class="text-secondary course-hours" style="padding-left: 7px;">({{ course.hours }} hours)</small>
                </div>
                <div class="mb-1">
                  <small v-if="type !== 'individual' && (course.days || course.time_from || course.time_end) && course.id !== 13532" class="text-secondary text-capitalize course-days">{{ course.days }} | <strong>{{ course.time_from }} - {{ course.time_to }}</strong></small>
                  <small v-if="type === 'individual' && course.id !== 13532" class="text-secondary">{{ individual.days.join(',') }} | {{ individual.time_start }} - {{ individual.time_end }}</small>
                </div>
                <!-- <strong>{{ course.price }}</strong> -->
                <coupon-input-component @onSetCouponCode="setCouponCode" :courseId="course.id" />
                <hr class="my-2">
              </div>
              <div class="d-flex px-2 align-items-center justify-content-between">
                <h5>Order total</h5>
                <h5 style="color: var(--primary)">
                  {{ total }} {{ currency }}
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="shallShowConfirmationStep" class="m-3">
        <div v-if="isLoading" class="d-flex justify-content-center m-5">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div v-if="!isLoading">
          <h5>Confirm your course</h5>
          <div class="shadow-sm rounded p-3 my-3">
            <div>
              <h5 class="text-start border-bottom pb-2 mb-3">Course summary</h5>
              <div v-for="course in courses" :key="course.id" class="d-flex mb-2 justify-content-between border-bottom">
                <div class="d-flex flex-row align-items-center">
                  <div>
                    <strong class="d-block mb-1" style="color: var(--primary)">{{ course.Name }}
                      <span v-if="course.master_course" :class="course.master_course.classroom_type === 'classroom' ? 'bg-danger' : 'bg-success'" class="badge">
                        {{ course.master_course.classroom_type }}
                      </span>
                    </strong>
                    <span
                        v-if="course.date_start || course.date_end"
                        class="text-secondary">
                        {{ formatDate((type !== 'individual' ? course : individual).date_start) }} to {{ formatDate((type !== 'individual' ? course : individual).date_end) }}
                      </span>
                      <span class="text-secondary">({{ course.hours }}h)</span>

                      <p v-if="type !== 'individual' && (course.days || course.time_from || course.time_end)" class="text-secondary">{{ course.days }} | {{ course.time_from }} - {{ course.time_to }}</p>
                      <p v-if="type === 'individual' && (course.days || course.time_from || individual.time_start || individual.time_end || individual.days)" class="text-secondary">{{ individual.days.join(',') }} | {{ individual.time_start }} - {{ individual.time_end }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-end mt-3">
              <strong style="color: var(--primary)">
                {{ courses.map(course => parseInt(course.price, 10)).reduce((a, b) => a + b, 0) }} {{ currency }}
              </strong>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    import "bootstrap"
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css';
    import ForgotPassword from './ForgotPassword.vue'
    import CouponInputComponent from './couponInputComponent'
    export default {
        name: "RegistrationComponent",
        emits: ["return_wizard", "form_data", "onCouponData"],
        components: {
          CouponInputComponent,
          ForgotPassword,
          vSelect,
        },
        created() {
          this.fetchPayers()
          this.fetchCountries()
          setTimeout(() => {
            this.calculateTotal() // @todo: have to be triggred after download course data
          }, 1000)
        },
        methods: {
          calculateTotal(){
            let total = this.courses.map(course => parseFloat(course.Discounted.price ?? course.price)).reduce((a, b) => a + b, 0)
            if(this.coupon !== null && this.coupon.coupon_type !== '') {
              total = this.coupon.after_coupon
            }

            this.total = total
            return total
          },
          setCouponCode(payload){
            this.coupon = payload
            this.calculateTotal()
            this.$emit('onCouponData', payload)
          },
          fetchCountries() {
            fetch(`${process.env.VUE_APP_BASEURI}/countries/list?perPage=600`)
            .then(response => {
              if (response.ok) {
                response.json().then(res => {
                  this.countries = res.rows
                })
              }
              else {
                response.json().then(err => {
                  if (!err.success) console.log(err)
                })
              }
            })
          },
          fetchPayers() {
            fetch(`${process.env.VUE_APP_BASEURI}/payers/list`)
            .then(response => {
              if (response.ok) {
                response.json().then(res => {
                  this.payerOptions = res.rows.map(el => el.code === 'student' ? { id: el.id, name: 'Me', code: el.code } : el)
                  this.register.who_pays = this.payerOptions.find(payer => payer.code === 'student')
                })
              }
              else {
                response.json().then(err => {
                  if (!err.success) console.log(err)
                })
              }
            })
          },
          checkEmail() {
            this.isLoadingCheck = true
            fetch(`${process.env.VUE_APP_BASEURI}/check/email`, {
              method: 'POST',
              headers: {
                  'Accept': 'application/json, text/plain, */*',
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify({ email: this.initEmail })
            })
            .then(response => {
              if (response.ok) {
                response.json().then(res => {
                  console.log(res.exist)
                  this.$emit('toggle-register', res.exist, true)
                  this.isLoadingCheck = false
                  this.isFirstStep = !res.exist
                  console.log(this.errorMessageLog)
                })
              }
              else {
                  response.json().then(err => {
                      if (!err.success) {
                        console.log(err)
                      }
                  })
              }
            })
            this.isFirstStep = false
          },
          checkRegistrationEmail() {
            if (this.register.email) {
              fetch(`${process.env.VUE_APP_BASEURI}/check/email`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email: this.register.email })
              })
              .then(response => {
                if (response.ok) {
                  response.json().then(res => {
                    if (res.exist) return this.$emit('update-registration-error-message', 'The email has already been taken.')
                    return this.$emit('reset-errorMessage')
                  })
                }
                else {
                  response.json().then(err => {
                    if (!err.success) {
                          this.$emit('update-registration-error-message', err.errors.email[0])
                          console.log(err)
                        }
                    })
                }
              })
            }
          },
          translate(text) {
            const el = this.el
              const language = {
                  fr: {
                    dob: '',  
                    register: 'S\'inscrire',
                    login: 'Connexion',
                    back: 'Rotour',
                    summary: 'Résumé',
                    hasAccount: 'Vous avez déjà un compte?',
                    checkout: 'Passer à la caisse',
                    firstTime: 'Première fois ici?',
                    checkbox1: 'Je suis un étudiant étranger et j\'ai besoin d\'une lettre d\'admission',
                    checkbox2: 'J\'ai lu et accepté le règlement des écoles d\'Alfaskolen, les conditions d\'inscription (conditions contractuelles) et les conditions de paiement',
                  }
              }
              if (el.dataset.lang === 'fr') {
                if (text === 'Register') return language.fr.register
                if (text === 'Login' || text === 'Sign in') return language.fr.login
                if (text === 'Summary') return language.fr.summary
                if (text === 'I have read and accepted Alfaskolen\'s schools regulations, registration conditions (contract terms) and payment terms.') return language.fr.checkbox2
                if (text === 'Proceed to Checkout') return language.fr.checkout
                if (text === 'Back') return language.fr.back
                if (text === 'Already have an account?') return language.fr.hasAccount
                if (text === 'First time here?') return language.fr.firstTime

              }
              return text
          },
          formatDate(dateTime) {
            if (dateTime) {
              const date = dateTime.split(' ')[0]
              const dd = date.split('-')[2]
              const mm = date.split('-')[1]
              const yyyy = date.split('-')[0]
              return `${dd}-${mm}-${yyyy}`
            }
            return ''
          },
          listenBack : function () {
            document.getElementById('Main-App').scrollIntoView()
            this.$emit('reset-errorMessage')
            this.$emit('return_wizard', {isWizard: true})
          },
          listenRegister : function (action) {
            if (action === 'login') {
                this.$emit('ShowConfirmationStep', true)
                return this.$emit('form_data', this.login, action)
              }
            if (!this.studentIsThePayer) {
              delete this.register.password
            }
            const payload = { ...this.register }
            payload.phone = `${this.Pcountry.dial_code}${payload.phone}`
            payload.language = this.el.dataset.lang
            // payload.checkData = 'yes'
            payload.courses = this.courses.length > 0 ? this.courses.map(course => course.id ? course.id : 9999999) : []
            payload.payer = payload.payer.id
            payload.companyPaymentMethod = payload.companyPaymentMethod.toLowerCase()
            this.$emit('ShowConfirmationStep', true)
            this.$emit('form_data', payload, action)
          },
          checkout(action) {
            document.getElementById('Main-App').scrollIntoView()
            if (action === 'login') {
              this.login.email = this.initEmail
              // this.$emit('ShowConfirmationStep', true)
              return this.$emit('form_data', this.login, action)
            }
            if (action === 'login') {
              this.$emit('checkout', this.login, action)
            }
            else {
              const payload = { ...this.register }
              // payload.email = this.initEmail
              payload.dob = payload.dob ? payload.dob : `${this.initDob.split('/')[2]}-${this.initDob.split('/')[1]}-${this.initDob.split('/')[0]}`
              payload.country = payload.country ? payload.country.name : payload.country
              payload.nationality = payload.nationality ? payload.nationality.nationality : payload.nationality
              payload.courses = this.courses.length > 0 ? this.courses.map(course => course.id ? course.id : 9999999) : []
              payload.payer_id = payload.who_pays ? payload.who_pays.id : null
              payload.companyPaymentMethod = payload.companyPaymentMethod.toLowerCase()
              if (this.Pcountry) {
                payload.phone = `${this.Pcountry.dial_code}${payload.phone}`
              }
              payload.language = this.el.dataset.lang
              payload.isCoupon = this.coupon // add coupon to registration data
              this.$emit('checkout', payload, action)
            }
          },
          bDateListener() {
            var isShift = false;
            var seperator = "/";
              //Reference the Table.
            setTimeout(() => {
              var inputs = document.getElementById('tblForm').getElementsByTagName("input");
      
              //Loop through all INPUT elements.
              for (var i = 0; i < inputs.length; i++) {
                  //Check whether the INPUT element is TextBox.
                  if (inputs[i].type == "text") {
                      //Check whether Date Format Validation is required.
                      if (inputs[i].className.indexOf("date-format") != 1) {
                            
                          //Set Max Length.
                          inputs[i].setAttribute("maxlength", 10);
      
                          //Only allow Numeric Keys.
                          inputs[i].onkeydown = function (e) {
                              return IsNumeric(this, e.keyCode);
                          };
      
                          //Validate Date as User types.
                          inputs[i].onkeyup = function (e) {
                              ValidateDateFormat(this, e.keyCode);
                          };
                      }
                  }
              }
          
              function IsNumeric(input, keyCode) {
                  if (keyCode == 16) {
                      isShift = true;
                  }
                  //Allow only Numeric Keys.
                  if (((keyCode >= 48 && keyCode <= 57) || keyCode == 8 || keyCode <= 37 || keyCode <= 39 || (keyCode >= 96 && keyCode <= 105)) && isShift == false) {
                      if ((input.value.length == 2 || input.value.length == 5) && keyCode != 8) {
                          input.value += seperator;
                          this.initDob = input.value
                      }
          
                      return true;
                  }
                  else {
                      return false;
                  }
              }
          
              function ValidateDateFormat(input, keyCode) {
                var dateString = input.value;
                  if (dateString.length === 10) {
                    const PureInput = dateString.replace('/', '').replace('/', '');
                    input.value = `${PureInput.slice(0, 2)}/${PureInput.slice(2, 4)}/${PureInput.slice(4, 8)}`
                    dateString = input.value
                  }
                  if (keyCode == 16) {
                      isShift = false;
                  }
                  var regex = /(((0|1)[0-9]|2[0-9]|3[0-1])\/(0[1-9]|1[0-2])\/((19|20)\d\d))$/;
          
                  //Check whether valid dd/MM/yyyy Date Format.
                  if (regex.test(dateString) || dateString.length == 0) {
                      ShowHideError(input, "none");
                      document.getElementById('dobInput').classList.remove('is-invalid')
                  } else {
                      ShowHideError(input, "block");
                      document.getElementById('dobInput').classList.add('is-invalid')
                  }
              }
          
              function ShowHideError(textbox, display) {
                  var row = textbox.parentNode.parentNode;
                  var errorMsg = row.getElementsByTagName("small")[0];
                  if (errorMsg != null) {
                      errorMsg.style.display = display;
                  }
              }
            }, 500)
            //Reference all INPUT elements in the Table.
          }
        },
        props: {
          errorMessageReg: Object,
          errorMessageLog: String,
          type: String,
          courses: Array,
          individual: Object,
          shallShowConfirmationStep: Boolean,
          isLoading: Boolean,
          alreadyRegistered: Boolean,
          registerReplacer: Object,
          loginRegister: Boolean,
        },
        data(){
            return {
                schoolContact: process.env.VUE_APP_CONTACT_URL,
                schoolName: process.env.VUE_APP_SCHOOLNAME,
                currency: process.env.VUE_APP_CURRENCY ? process.env.VUE_APP_CURRENCY : 'Kr',
                countries: [],
                payerOptions: [],
                isLoadingCheck: false,
                isValidinitEmail: false,
                initEmail: null,
                isFirstStep: true,
                initDob: null,
                Pcountry: null,
                emailRepeat: null,
                emailRepeatErr: false,
                forgotPs: false,
                // phone: null,
                el: document.querySelector('#placementtestapp'),
                studentIsThePayer: true,
                // shallShowCountries: false,
                isActive: false,
                company: false,
                howHeareds: ['Advertisement', 'Career services', 'Conference', 'Email', 'Employer', 'Fair/info session', 'Friend/Relative', 'I attend(ed) Middlebury', 'Internet', 'Phone', 'Poster', 'Professor', 'Social media', 'Study Abroad Office', 'Other'],
                register: {
                  comments: '',
                  gender: 'male',
                  companyPaymentMethod: 'Card',
                  howHeared: '',
                  firstname: '',
                  lastname: '',
                  email: '',
                  phone: null,
                  postcode: null,
                  payer_name: null,
                  company_number: null,
                  responsible: null,
                  payer_address: null,
                  payer_phone: null,
                  payer_email: null,
                  who_pays: {},
                  // visa: false,
                  // password: '',
                  // payer_tel: null,
                  // payer_postcode: null,
                },
                login: {
                  email: null,
                  password: null,
                },
                termsLink: process.env.VUE_APP_CONDITIONS,
                coupon: null,
                total: 'Processing total ...',
            }
        },
        computed: {
          theTotal() {
            return this.calculateTotal()
          },
          isAdmission() {
            if (this.courses.length > 0 && this.courses[0].Name === 'ADMISSION') {
              return this.payerOptions.filter(el => el.code !== 'nav' && el.code !== 'duo' && el.code !== 'imdi')
            }
            return this.payerOptions
            // if(this.courses[0].Name !== "undefined"){
            //   if(this.courses[0].Name === "ADMISSION"){
            //     return  this.payerOptions.map((v) => {
            //       if (v.code !== 'nav' && v.code !== 'duo')
            //       return v
            //     })
            //   }
            //   return this.payerOptions
            // }
            // return this.payerOptions
          },
          isDiscounted() {
            return typeof this.courses[0] !== "undefined" && typeof this.courses[0].Discounted.price !== "undefined" && (this.courses[0].Discounted.is_discount || this.courses[0].Discounted.is_earlybird);
          },
          isCoupon() {
            return this.coupon !== null;
          },
        },
        watch: {
          // whenever question changes, this function will run
          // isLoadingCheck: function () {
          //   if (this.isLoadingCheck) {
          //   setTimeout(() => {
          //     this.bDateListener()
          //   },500)
          //   }
          // },
          registerReplacer: function() { // watch it
            console.log(this.registerReplacer)
            this.register.firstname = this.registerReplacer.lastname ? this.registerReplacer.firstname : null
            this.register.lastname = this.registerReplacer.lastname ? this.registerReplacer.lastname : null
            if (this.registerReplacer.dob) {
              this.formatDate(this.registerReplacer.dob).replace('-', '/').replace('-', '/')
              this.register.dob = this.registerReplacer.dob
            }
            this.register.email = this.registerReplacer.email ? this.registerReplacer.email : null
            this.register.gender = this.registerReplacer.gender ? this.registerReplacer.gender : 'male'
            this.register.address = this.registerReplacer.address ? this.registerReplacer.adress : null
            this.register.postcode = this.registerReplacer.postcode ? this.registerReplacer.postcode : null
            this.register.city = this.registerReplacer.city ? this.registerReplacer.city : null
            this.register.country = this.registerReplacer.country ? this.registerReplacer.country : null
            this.register.nationality = this.registerReplacer.nationality ? this.registerReplacer.nationality : null
            this.register.phone = this.registerReplacer.phone ? this.registerReplacer.phone : null
            // this.register.email = this.registerReplacer.email
          }
        },
      }
</script>

<style scoped src="../assets/bootstrap.min.css"></style>
<style scoped>
.line-with-text {
  display: flex;
  align-items: center; /* center the text vertically */
}

.line-with-text::before,
.line-with-text::after {
  content: "";
  flex: 1; /* take up all available space */
  border-top: 1px solid black; /* the line style */
  margin: 0 10px; /* the distance between the line and the text */
}

.line-with-text span {
  font-size: 18px; /* the font size of the text */
  font-weight: bold; /* the font weight of the text */
}
.btn-primary {
      background-color: var(--primary) !important;
      border-color: var(--primary) !important;
  }
  .btn:focus{
    box-shadow:none !important;
  }
  input {
    display: block;
  }
  select, input:focus {
    box-shadow:none !important;
    border-color: var(--primary) !important;
  }
  .form-check-input.checked {
      background-color: var(--primary) !important;
      border-color: var(--primary) !important;
  }
</style>
<style>
.dob-select {
  width: 100px;
}
.dob-select .vs__dropdown-toggle {
  border-top: none;
  border-right: none;
  border-left: none;
}
.badge .bg-danger {
  background-color: var(--primary) !important;
}
body {
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
}
.vs__selected-options {
  height: 32px;
}
</style>